export const CATEGORY_REQUEST = 'CATEGORY_REQUEST'
export const CATEGORY_SUCCESS = 'CATEGORY_SUCCESS'
export const CATEGORY_FAIL = 'CATEGORY_FAIL'

export const PRODUCTS_REQUEST = 'PRODUCTS_REQUEST'
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS'
export const PRODUCTS_FAIL = 'PRODUCTS_FAIL'

export const SEARCH_REQUEST = 'SEARCH_REQUEST'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAIL = 'SEARCH_FAIL'

export const CHANGE_CAT = 'CHANGE_CAT'

export const UPDATE_CART = "UPDATE_CART"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const ORDER_CONFIRMED = "ORDER_CONFIRMED"


// export const PRODUCT_DETAILS_REQUEST = 'PRODUCT_DETAILS_REQUEST'
// export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS'
// export const PRODUCT_DETAILS_FAIL = 'PRODUCT_DETAILS_FAIL'

